import { useContext } from "react";
import { StoreExecutorContext } from "../Contexts/Store/StoreExecutor";
import { NotificationCount } from "../core/executor_data";

// Пользовательский хук
export const useNotificationCount = () => {
  const context = useContext(StoreExecutorContext);
  const defaultNote = {
    note: {
      count: 0,
      isWait: false,
      isClose: false,
      isWork: false,
    } as NotificationCount,
  };
  if (!context) {
    return defaultNote;
  }
  const { dataExecutor } = context;

  if (!dataExecutor || !dataExecutor.notification) return defaultNote;
  return {
    note: dataExecutor.notification,
  };
};
